import { Labels, Login, Logout, Settings } from '../screens';

export const APP_ROOT = '/app/speedlabel';

export const ROUTE_MAP = {
    ROOT: `${APP_ROOT}/`,
    LOGIN: `${APP_ROOT}/login`,
    LOGOUT: `${APP_ROOT}/logout`,
    LABELS: `${APP_ROOT}/labels`,
    LABELS_JOB_ID: `${APP_ROOT}/labels/:jobId`,
    SETTINGS: {
        ROOT: `${APP_ROOT}/settings`,
        TEMPLATES: `${APP_ROOT}/settings/templates`,
        TEMPLATE_ID: `${APP_ROOT}/settings/templates/:templateId`,
        SYMBOLS: `${APP_ROOT}/settings/symbols`,
        COLORS: `${APP_ROOT}/settings/colors`,
        COLOR_ID: `${APP_ROOT}/settings/colors/:colorId`,
        CHECKLISTS: `${APP_ROOT}/settings/checklists`,
        CHECKLIST_ID: `${APP_ROOT}/settings/checklists/:checklistId`,
        SPEED_LINK: `${APP_ROOT}/settings/speed-link`,
        REMNANT_TEMPLATE: `${APP_ROOT}/settings/remnant-template`,
        JOB_SHEET_TEMPLATE: `${APP_ROOT}/settings/job-sheet-template`,
        CUSTOM: `${APP_ROOT}/settings/custom`,
    },
};

export const ROUTES = [
    {
        authenticated: false,
        path: ROUTE_MAP.LOGIN,
        screen: Login,
        exact: true
    },
    {
        authenticated: false,
        path: ROUTE_MAP.LOGOUT,
        screen: Logout,
        exact: true
    },
    {
        authenticated: true,
        path: ROUTE_MAP.ROOT,
        screen: Login,
        exact: true
    },
    {
        authenticated: true,
        path: ROUTE_MAP.LABELS,
        screen: Labels,
        exact: true
    },
    {
        authenticated: true,
        path: ROUTE_MAP.LABELS_JOB_ID,
        screen: Labels,
        exact: true
    },
    {
        authenticated: true,
        path: ROUTE_MAP.SETTINGS.ROOT,
        screen: Settings,
        exact: false
    },
];

export const isPrivateRoute = (pathname) => {
    if (!pathname) {
        ({ pathname } = window.location);
    }
    return ROUTES.filter((r) => !r.authenticated).map((r) => r.path).indexOf(pathname) === -1;
};
